export default __webpack_public_path__ + "static/media/button_point-off.8800cd1a.svg";